import React from "react";

const Test = () => {
  return <text>Test</text>;
};

export default Test;
